import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EMAIL_REGEX } from '@core/enums/patterns';
import { ILoginRequest } from '@core/interfaces/ilogin-request';
import { IRequestAccount } from '@core/interfaces/irequest-account';
import { IUser } from '@core/interfaces/iuser';
import { AuthService } from '@core/services/auth.service';
import { UserService } from '@core/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  mainTitle = 'Forgot Password?';
  forgotPwdForm: FormGroup | any;
  private subscriptions = new Subscription();

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.initializeForms();
  }
  get email() {
    return this.forgotPwdForm.get('email');
  }

  initializeForms(): void {
    this.forgotPwdForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.maxLength(250),
          Validators.pattern(EMAIL_REGEX),
        ],
      ],
    });
  }

  handleSubmit(): void {
    this.subscriptions.add(
      this.authService
        .forgotPassword(this.email.value)
        .subscribe((res: any) => {
          if (res) {
            this.toastr.success(
              'An email was sent to you to reset your password.'
            );
            this.router.navigateByUrl('/login');
          }
        })
    );
  }
}
